import angular from 'angular';
import config from '@/config';

angular
  .module('cloudX')
  .controller('ChangePasswordDialogCtrl', [
    '$element',
    'resourceFactorySvc',
    'flySvc',
    'close',
    '$timeout',
    '$window',
    changePasswordDialogCtrl,
  ]);

function changePasswordDialogCtrl($element, resourceFactorySvc, flySvc, close, $timeout, $window) {
  var vm = this;

  vm.data = {
    oldPassword: '',
    newPassword: '',
    newPassword2: '',
    captcha: '',
    captchaAction: 'change_password',
  };

  vm.showCaptcha = function() {
    $window.grecaptcha.enterprise.render('g-recaptcha', {
      sitekey: config.recaptchaKey,
      action: vm.data.captchaAction,
      callback: function(token) {
        $timeout(() => {
          vm.data.captcha = token;
        });
      },
    });
  };

  $timeout(vm.showCaptcha);

  vm.save = function() {
    vm.saving = true;
    resourceFactorySvc.get('user').changePassword(
      null,
      vm.data,
      function() {
        vm.saving = false;
        flySvc.success('msgPasswordChanged');
        close(true, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
